import React from "react";
import * as translation from "react-multi-lang";
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <div className="container">
                <div className="row">
                    <div className="col align-self-center">
                        <div>
                            <div className="text-center">
                                <div className="imagealign">
                                    <img src="./images/Nouserrights/errorhandling.png" alt="" height="250" />
                                </div>
                                <div className="textwrapalign">
                                    <h1>{translation.t("Common.IDS_MSG_404ERROR")}</h1>
                                    <ul className="list-unstyled">
                                        <li className="norights">
                                            {translation.t("Common.IDS_MSG_ERRORMSG")}
                                        </li>
                                        <li className="norights">

                                            <button
                                                className="btn btn-primary-blue"
                                                onClick={() => {
                                                    // navigate(placeToGo, { replace: true });
                                                    window.location.reload();
                                                }}
                                            >
                                                {translation.t("Inventory.IDS_REFRESH")}
                                            </button>
                                        </li>
                                        <li className="norights">
                                            <a
                                                href="https://agaramtech.freshdesk.com/support/login"
                                                // target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {translation.t("Common.IDS_LBL_CONTACTUS")}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div>
                        </div>
                    </div>

                </div>
            </div>;
        }

        return this.props.children;
    }
}
export default ErrorBoundary;